import { gql } from "@apollo/client";

export const EDIT_COACH_MUTATION = gql`
  mutation EditCoach(
    $userUuid: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $phone: String!
    $country: String!
    $countrycode: String!
    $locale: String!
    $timeZone: String!
    $snowflakeUUID: [String!]!
    $bio: [JSON!]!
    $originalToken: String
    $title: String
    $consultationUrl: String
    $cnConsultationUrl: String
    $avatarFilename: String
    $disabled: Boolean
  ) {
    editCoach(
      userUuid: $userUuid
      email: $email
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      country: $country
      countrycode: $countrycode
      locale: $locale
      timeZone: $timeZone
      snowflakeUUID: $snowflakeUUID
      bio: $bio
      originalToken: $originalToken
      title: $title
      consultationUrl: $consultationUrl
      cnConsultationUrl: $cnConsultationUrl
      avatarFilename: $avatarFilename
      disabled: $disabled
    ) {
      returnMessage {
        status
        message
        __typename
      }
      __typename
    }
  }
`;

export interface EditCoachData {
  editCoach: {
    returnMessage: {
      status: string;
      message: string;
      __typename: string;
    };
    __typename: string;
  };
}

export interface EditCoachVariables {
  userUuid: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  country: string;
  countrycode: string;
  locale: string;
  timeZone: string;
  snowflakeUUID: Array<String>;
  bio: Array<{
    unique_bio_id?: string;
    bio: string;
    language: string;
  }>;
  originalToken?: string;
  title?: string;
  consultationUrl?: string;
  cnConsultationUrl?: string;
  avatarFilename?: string;
  disabled?: boolean;
}
